import { defineMessages } from 'react-intl';

export const reportsMessages = defineMessages({
  noData: {
    id: 'reports.noData',
    defaultMessage: 'Brak danych dla wybranych filtrów',
  },
});
